// @ts-nocheck

import React, { useEffect } from 'react';
import type { Node } from 'react';
import styled from 'styled-components';

import { useShowLogin } from '../../hooks';
import { __ } from '../../i18n/l10n';
import HistoryItemContainer from '../HistoryItem/HistoryItemContainer';
import NotFoundView from '../NotFoundView';
import WinaLoader from '../WinaLoader';

const Wrapper = styled.div`
  position: relative;
`;

const Content = styled.div`
  color: ${({ theme }) => theme.common.colors.defaultFontColor};
  line-height: normal;
`;

const EmptyList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
`;

type HistoryItemDetailProps = {
  askBetslipInfo: (betslipReference: string) => void;
  betslipReferencesToFetch: Array<string>;
  betslipIds: Array<number>;
  connected: boolean;
  needFetchBetslip: boolean;
  canFetch: boolean;
};

const HistoryItemDetail = ({
  askBetslipInfo,
  betslipReferencesToFetch,
  betslipIds,
  connected,
  needFetchBetslip,
  canFetch,
}: HistoryItemDetailProps): Node => {
  useShowLogin();

  useEffect(() => {
    if (canFetch && betslipReferencesToFetch.length !== 0) {
      betslipReferencesToFetch.forEach((betslipReference) => askBetslipInfo(betslipReference));
    }
  }, [askBetslipInfo, betslipReferencesToFetch, needFetchBetslip, canFetch]);

  return (
    <Wrapper>
      <Content>
        {connected ? (
          <>
            {betslipIds.length > 0
              ? betslipIds.map((betslipId) => <HistoryItemContainer key={betslipId} id={betslipId} />)
              : null}
            {betslipIds.length === 0 && betslipReferencesToFetch.length === 0 ? (
              <NotFoundView label={__('No bets')} />
            ) : null}
            {betslipIds.length === 0 && betslipReferencesToFetch.length !== 0 ? (
              <EmptyList>
                <WinaLoader />
              </EmptyList>
            ) : null}
          </>
        ) : (
          <NotFoundView label={__('You must be logged')} />
        )}
      </Content>
    </Wrapper>
  );
};

export default HistoryItemDetail;
